function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icons8-git",
  d: "M89.6,41.283,52.673,4.358a8.054,8.054,0,0,0-11.389,0l-7.3,7.3L43.024,20.7A7.786,7.786,0,0,1,53.7,31.375l8.884,8.884a7.823,7.823,0,1,1-2.765,2.765L50.93,34.14a7.731,7.731,0,0,1-2,.823V58.987a7.822,7.822,0,1,1-3.911,0V34.965A7.738,7.738,0,0,1,40.261,23.47l-9.044-9.044L4.358,41.283a8.052,8.052,0,0,0,0,11.387L41.283,89.6a8.052,8.052,0,0,0,11.389,0L89.6,52.673A8.054,8.054,0,0,0,89.6,41.283Z",
  transform: "translate(-2 -2)"
});

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.956,
    height: 89.956,
    viewBox: "0 0 89.956 89.956",
    transform: "translate(0 5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/Git.b4415d18.svg";
export { ForwardRef as ReactComponent };